import styled from "styled-components";
import {LIVE_CASINO_PAGE} from "../../../themes/css-global-classes";
import {CssRule} from "../../../themes/architecture/css-helpers/css-rule";

export const MainWrapperDefaultBox = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  /* For iPhones with notch, the margins and the sizes (width and height need to be adjusted) for any other devices, env() will return 0.
  I will also keep height: 100% and width: 100% for devices that do not support env at all
   */
  margin: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  height: 100%;
  width: 100%;
  width: calc(100% - env(safe-area-inset-right) - env(safe-area-inset-left));
  height: calc(100% - env(safe-area-inset-top) - env(safe-area-inset-bottom));

  ${CssRule.For.embededHybrid.build()} & {
      .${LIVE_CASINO_PAGE} & {
          padding-top: calc(env(safe-area-inset-top) + 1rem);
      }
  }
`;